import React, { useMemo } from 'react';
import { ChartPropertyType } from '../statisticsModalChartLib';
import { StatisticsModalType } from '../../statisticsLib';
import { StatisticsModalChart } from '../StatisticsModalChart';
import { Spin } from 'antd';
import StatisticsModalChartTooltip from '../StatisticsModalChartTooltip';
import { useGetStatsRoutesQuery } from '../../apiCalculationStatistics';
import { useSelector } from 'react-redux';
import { ReduxState } from '../../../../../store';
import { useApplicationData } from '../../../../../hooks/useApplicationData';
import { CalculationStatisticClusterType } from '@ydistri/api-sdk';

interface StatisticsModalChartRouteProps {
  chartValueType: ChartPropertyType<StatisticsModalType.ROUTE>;
  calculationId: number;
}

const StatisticsModalChartRoute: React.FC<StatisticsModalChartRouteProps> = ({
  chartValueType,
  calculationId,
}) => {
  const departmentId = useSelector((state: ReduxState) => state.statistics.departmentId);

  const { departments: hasDepartments } = useApplicationData();
  const clusterType = useSelector((state: ReduxState) => state.statistics.clusterType);
  const showDepartments =
    hasDepartments && clusterType === CalculationStatisticClusterType.StoreDepartment;

  const { data: routeData, isFetching } = useGetStatsRoutesQuery({
    calculationId,
    departmentId,
    tableOrChart: 'chart',
    skip: 0,
    clusterType,
  });

  const data = useMemo(() => routeData ?? [], [routeData]);

  const customTooltipId = 'chart-js-tooltip-route';

  return (
    <Spin spinning={isFetching}>
      <StatisticsModalChart
        statisticsModalType={StatisticsModalType.ROUTE}
        customTooltipId={customTooltipId}
        chartValueType={chartValueType}
        data={data}
      />
      <StatisticsModalChartTooltip
        chartValueType={chartValueType}
        showDepartments={showDepartments}
        modalType={StatisticsModalType.ROUTE}
        customTooltipId={customTooltipId}
      />
    </Spin>
  );
};

export default StatisticsModalChartRoute;
